module.exports = __webpack_public_path__ + "static/assets/009ded64766efc2d5291c1492df124e8.svg";